import React from 'react'
import * as R from 'ramda'

export const useContext = ctxt => {
  if (R.isNil(ctxt)) {
    throw new Error('Context was not provided!')
  }

  const context = React.useContext(ctxt)

  return context
}
